// components
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface OrganiserAdminBlockedPageProps {
  onGoBack?: () => void;
}

export const OrganiserAdminBlockedPage = ({
  onGoBack,
}: OrganiserAdminBlockedPageProps) => {
  return (
    <CenterPageTemplate>
      <FloatingContent
        title='Sign in as a member'
        description='Actions is only available when signed in as a member. Please sign in with a member account to view and manage actions.'
        actions={
          onGoBack
            ? [
                {
                  label: 'Go Back',
                  variant: 'primary',
                  onClick: onGoBack,
                },
              ]
            : undefined
        }
      />
    </CenterPageTemplate>
  );
};

OrganiserAdminBlockedPage.displayName = 'OrganiserAdminBlockedPage';
export default OrganiserAdminBlockedPage;
